import { styled } from '$utils/theme'
import { Block } from '../Layout/Block'
import { rem } from 'polished'
import { Text } from '../Text'
import { Link } from '../Link'

export const CookieBannerWrapper = styled(Block).attrs({})`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: ${rem(555)};
  left: 0;
  bottom: 0;
  background-color: white;
  position: fixed;
  z-index: 3;
  border: solid 1px #eaeaea;
  padding: 16px 24px;
  margin-left: 16px;
  margin-bottom: 16px;

  ${p =>
    p.theme.media.onlyMobile`
      flex-direction: column;
      width: 100%;
      height: auto;
      margin: 0;
      border-top: solid 1px ${p.theme.colors.darkGrey};
      background-color: ${p.theme.colors.darkGrey};
    `};
`

export const StyledText = styled(Text)`
  ${p => p.theme.media.onlyMobile`
  color: white;
  font-size: 13px;
`};
`

export const StyledLink = styled(Link)`
  ${p => p.theme.media.onlyMobile`
  color: white !important;
  text-decoration: underline !important;
`};
`



// WEBPACK FOOTER //
// ./src/views/components/CookieBanner/CookieBanner.style.ts